import { pasteCopiedTasks } from "./paste";
export function duplicateSelectedTasks({ store }) {
    const { selected } = store.getState();
    store.eachSelected((id, index) => {
        store.in.exec("copy-task", {
            id,
            join: !!index,
        });
        if (selected.length - 1 === index)
            pasteCopiedTasks({ store });
    }, true);
}
//# sourceMappingURL=duplicate.js.map